import React, { Component } from "react";
import { connect } from "react-redux";
import { CreativeComponent } from "./CreativeComponent";
import {
  setCurrentCreative,
  setCurrentTab,
  getPreflightReport
} from "./../../../redux/actions/index";
import { Input } from "antd";
import { setTableFieldPairs } from "../../../components/Helpers";

const { TextArea } = Input;

const mapDispatchToProps = dispatch => {
  return {
    setCurrentCreative: admaterial => dispatch(setCurrentCreative(admaterial)),
    setCurrentTab: key => dispatch(setCurrentTab(key)),
    getPreflightReport: admaterial => dispatch(getPreflightReport(admaterial))
  };
};

const mapStateToProps = state => {
  return {
    booking: state.booking,
    preflightReport: state.preflightReport,
    language: state.language,
    configuration: state.configuration,
    tableFields: state.tableFields,
    tableFieldsPrint: state.tableFieldsPrint,
    fieldTranslations: state.fieldTranslations,
    currentMatspec: state.currentMatspec,
    currentTab: state.currentTab,
    previousTab: state.previousTab
  };
};

class CreativeContainer extends Component {
  onClick = props => {
    const {
      setCurrentCreative,
      admaterial,
      setCurrentTab,
      getPreflightReport,
      tableFields,
      fieldTranslations,
      configuration
    } = this.props;
    setCurrentCreative(admaterial);
    getPreflightReport(admaterial);
    setCurrentTab("4");
  };
  componentDidMount() {
    const { booking, currentMatspec, previousTab } = this.props;
    if (booking.currentAdMaterial && previousTab !== "4") {
      this.onClick();
      return;
    }
    if (currentMatspec.admaterial.length === 1 && previousTab !== "4") {
      this.onClick();
      return;
    }
    //console.log("component did mount");
    //const { currentMatspec, currentTab } = this.props;
    //if (currentMatspec.printed && currentTab === 3) this.onClick();
  }
  componentWillUnmount() {
    console.log("unmounting");
  }
  render() {
    const {
      admaterial,
      key,
      language,
      configuration,
      fieldTranslations,
      currentMatspec
    } = this.props;
    const tableData = setTableFieldPairs(
      configuration.tableFieldsCreativeMobile,
      fieldTranslations,
      admaterial,
      currentMatspec
    );
    return (
      <CreativeComponent
        key={key}
        admaterial={admaterial}
        language={language}
        onClick={this.onClick}
        tableData={tableData}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreativeContainer);

//THIS SHOULD BE MIGRATED TO MATSPECCOPONENT???



// WEBPACK FOOTER //
// ./src/components/Mobile/Creative/CreativeContainer.js